// import Vue from 'vue'
import { createApp } from 'vue'
import App from './App.vue'
import "./assets/global.css"

// import VueRouter from 'vue-router'
import { createPinia } from 'pinia';
import { createWebHistory, createRouter } from "vue-router";
import IndexComponent from './components/admin/dashboard/IndexComponent.vue'
import DummyView from './components/admin/dashboard/DummyView.vue'
import CanfieldComponent  from './components/admin/dataProcessing/CanfieldComponent.vue'
import PatientComponent  from './components/admin/patient/PatientComponent.vue'
import PatientDetailsComponent from './components/admin/patient/PatientDetailsComponent.vue'
import DataProcessingComponent from './components/admin/patient/DataProcessingComponent.vue';
import ReportPageComponent from './components/admin/ReportPage/ReportPageComponent.vue';
import TypographyComponent from './components/admin/uielements/TypographyComponent.vue'
import TabsComponent from './components/admin/uielements/TabsComponent.vue'
import ButtonsComponent from './components/admin/uielements/ButtonsComponent.vue'
import BootstrapComponent from './components/admin/uielements/BootstrapComponent.vue'
import IconComponent from './components/admin/uielements/IconComponent.vue'
import NotificationComponent from './components/admin/uielements/NotificationComponent.vue'
import ColorComponent from './components/admin/uielements/ColorComponent.vue'
import ListGroupComponent from './components/admin/uielements/ListGroupComponent.vue'
import MediaComponent from './components/admin/uielements/MediaComponent.vue'
import ModalComponent from './components/admin/uielements/ModalComponent.vue'
import ProgressbarComponent from './components/admin/uielements/ProgressbarComponent.vue'
import BlogComponent from './components/admin/widgets/BlogComponent.vue'
import LoginComponent from './components/admin/authentication/LoginComponent.vue'
import RegisterComponent from './components/admin/authentication/RegisterComponent.vue'
import LockscreenComponent from './components/admin/authentication/LockscreenComponent.vue'
import ForgotPasswordComponent from './components/admin/authentication/ForgotPasswordComponent.vue'
import ResetPasswordComponent from './components/admin/authentication/ResetPasswordComponent.vue'
import FourZeroFourComponent from './components/admin/authentication/FourZeroFourComponent.vue'
import FourZeroThreeComponent from './components/admin/authentication/FourZeroThreeComponent.vue'
import FiveZeroZeroComponent from './components/admin/authentication/FiveZeroZeroComponent.vue'
import FiveZeroThreeComponent from './components/admin/authentication/FiveZeroThreeComponent.vue'
import ProfileComponent from './components/admin/pages/ProfileComponent.vue'
import ProfiletwoComponent from './components/admin/pages/ProfiletwoComponent.vue'
import SearchComponent from './components/admin/pages/SearchComponent.vue'
import MaintananceComponent from './components/admin/pages/MaintananceComponent.vue'
import NormalComponent from './components/admin/patient/PDFComponent.vue'
import PFLChartComponent from './components/admin/charts/PFLCharts.vue'
import GrowthChartComponent from './components/admin/charts/GrowthCharts.vue'
import ClinicalAssessmentComponent from './components/admin/clinicalAssessment/ClinicalAssessmentComponent.vue'


import "./vee-validate";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css'
import CKEditor from '@ckeditor/ckeditor5-vue';
import mitt from 'mitt';
import VTooltip from 'floating-vue'
import 'floating-vue/dist/style.css'


const app = createApp(App);
const emitter = mitt();
app.config.globalProperties.emitter = emitter;

const pinia = createPinia();

const routes= [
    {
        path: '',
        name: 'dashboard',
        redirect: '/authentication/page-login',
        component: DummyView,
        meta: {
            breadCrumb: 'Dashboard',
        },
        children: [
            { path: 'dashboard', component: IndexComponent, meta: { breadCrumb: "Index", title: "Dashboard", },},
        ]
    },
    {
        path: '/app',
        redirect: '/app',
        component: DummyView,
        meta: {
            breadCrumb: 'App',
        },
        children: [
            {
                path: "app-inbox",
                component: DummyView,
                meta: { breadCrumb: "Inbox"},
            },
        ]
    },
    {
        path: '/data-processing',
        component: CanfieldComponent,
        meta: {
            breadCrumb: 'Data Processing',
        },
    },    
    {
        path: '/subjects',
        component: PatientComponent,  
        meta: {
            breadCrumb: 'Subjects',
            title: 'Subjects'
        }
    },
    {
        path: '/patients/:patientId',
        name: 'PatientDetails',
        component: PatientDetailsComponent,
        meta: {
          breadCrumb: 'Subject Details',
          title: 'Subject Details',
        },
      },
      
      {
        path: '/data-processing/:facescanId/:patientSubjectID',
        name: 'DataProcessing',
        component: DataProcessingComponent,
        props: true,
        meta: {
          breadCrumb: 'Data Processing',
          title: 'Data Processing',
        },
      },  
      {
        path: '/reportPage',
        component: ReportPageComponent,
        meta: {
            breadCrumb: 'Report Page',
        },
    },     
    
 
    {
        path: '/ui-elements',
        redirect: '/ui',
        component: DummyView,
        meta: {
            breadCrumb: 'UI Elements',
        },
        children: [
            { path: 'ui-typography', component: TypographyComponent, meta: { breadCrumb: "Typography", title: "Typography" },},
            { path: 'ui-tabs', component: TabsComponent, meta: { breadCrumb: "Tabs", title: "Tabs" },},
            { path: 'ui-buttons', component: ButtonsComponent, meta: { breadCrumb: "Buttons", title: "Buttons" },},
            { path: 'ui-bootstrap', component: BootstrapComponent, meta: { breadCrumb: "Bootstrap UI", title: "Bootstrap UI" },},
            { path: 'ui-icons', component: IconComponent, meta: { breadCrumb: "Icons", title: "Icons" },},
            { path: 'ui-notifications', component: NotificationComponent, meta: { breadCrumb: "Notifications", title: "Notifications" },},
            { path: 'ui-colors', component: ColorComponent, meta: { breadCrumb: "Colors", title: "Colors" },},
            { path: 'ui-listgroup', component: ListGroupComponent, meta: { breadCrumb: "List Group", title: "List Group" },},
            { path: 'ui-media', component: MediaComponent, meta: { breadCrumb: "Media Object", title: "Media Object" },},
            { path: 'ui-modals', component:ModalComponent, meta: { breadCrumb: "Modals", title: "Modals" },},
            { path: 'ui-progressbars', component: ProgressbarComponent, meta: { breadCrumb: "Progressbar", title: "Progressbar" },},
        ]
    },
    {
        path: '/widgets',
        redirect: '/widgets',
        component: DummyView,
        meta: {
            breadCrumb: 'Blog',
        },
        children: [
            { path: 'widgets-blog', component: BlogComponent, meta: { breadCrumb: "Widgets Blog",title: "Widgets Blog" },},
        ]
    },
    {
        path: '/authentication',
        redirect: '/page',
        component: DummyView,
        children: [
            { path: 'page-login', component: LoginComponent,name: 'login', meta: { title: "Login" }},
            { path: 'page-register', component: RegisterComponent ,name: 'register', meta: { title: "Register" }},
            { path: 'page-lockscreen', component: LockscreenComponent ,name: 'lockscreen', meta: { title: "Lockscreen" }},
            { path: 'page-forgot-password', component: ForgotPasswordComponent ,name: 'fpassword', meta: { title: "Forgot Password" }},
            { path: 'page-reset-password', component: ResetPasswordComponent ,name: 'rpassword', meta: { title: "Reset Password" }},
            { path: 'page-404', component: FourZeroFourComponent ,name: '404', meta: { title: "404 Page" }},
            { path: 'page-403', component: FourZeroThreeComponent ,name: '403', meta: { title: "403 Page" }},
            { path: 'page-500', component: FiveZeroZeroComponent ,name: '500', meta: { title: "500 Page" }},
            { path: 'page-503', component: FiveZeroThreeComponent ,name: '503', meta: { title: "503 Page" }},
        ]
    },
    {
        path: '/pages',
        redirect: '/page',
        component: DummyView,
        meta: {
            breadCrumb: 'Pages',
        },
        children: [
            { path: 'page-profile', component: ProfileComponent, meta: { breadCrumb: "User Profile",title: "User Profile" },},
            { path: 'page-profile2', component: ProfiletwoComponent, meta: { breadCrumb: "User Profile",title: "User Profile v2" },},
            { path: 'page-search-results', component: SearchComponent, meta: { breadCrumb: "Search Results",title: "Search Results" },},
            { path: 'page-maintanance', component: MaintananceComponent,name: 'maintanance', meta: {title: "Maintanance" },},
        ]
    },
  
     {
       path: '/table',
        redirect: '/table',
       component: DummyView,
       meta: {
            breadCrumb: 'Table',
        },
       children: [
           { path: 'table-normal', component: NormalComponent, meta: { breadCrumb: "Table Normal",title: "Table Normal" },},
        ]
     },
    {
        path: '/charts',
        redirect: '/chart',
        component: DummyView,
        meta: {
            breadCrumb: 'Charts',
        },
        children: [
            { path: 'chart-PFL', component: PFLChartComponent, meta: { breadCrumb: "PFL Charts",title: "PFL Charts" },},
            { path: 'chart-growth', component: GrowthChartComponent, meta: { breadCrumb: "Growth Charts",title: "Growth Charts" },},
        ]
    },
    {
        path: '/ClinicalAssessment',
        component: ClinicalAssessmentComponent,  
        meta: {
            breadCrumb: 'ClinicalAssessment',
            title: 'ClinicalAssessment'
        }
    },

    {
        path: '/*',
        redirect: '/dashboard'
    }
]
const router = createRouter({
    history: createWebHistory(),
    routes,
});
router.beforeEach((to, from, next) => {
    document.title = ' FaceScreen ';
    next();
});
router.beforeEach((to, from, next) => {
    const isAuthRoute = to.path.startsWith('/authentication');
    const hasToken = localStorage.getItem('userJWtoken');
    if (!isAuthRoute && !hasToken) {
        next('/authentication/page-login');
    } else {
        next();
    }
});

app.use(pinia)
app.use(router)
app.use(VueToast)
app.use(VTooltip)
app.use( CKEditor )
app.config.globalProperties.emitter = emitter;
app.mount('#app')
   